import { render, staticRenderFns } from "./WorkSchedule.vue?vue&type=template&id=e305523c&scoped=true&"
import script from "./WorkSchedule.vue?vue&type=script&lang=ts&setup=true&"
export * from "./WorkSchedule.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./WorkSchedule.vue?vue&type=style&index=0&id=e305523c&lang=scss&scoped=true&"
import style1 from "./WorkSchedule.vue?vue&type=style&index=1&id=e305523c&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e305523c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e305523c')) {
      api.createRecord('e305523c', component.options)
    } else {
      api.reload('e305523c', component.options)
    }
    module.hot.accept("./WorkSchedule.vue?vue&type=template&id=e305523c&scoped=true&", function () {
      api.rerender('e305523c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/WorkSchedule/WorkSchedule.vue"
export default component.exports